module.exports = __webpack_public_path__ + "static/media/V2_08.df21d34d.png";